export default {
  welcomeMessage: 'Try to build something great',
  unknownError: 'Unknown error',
  all: 'All',
  draft: 'Draft',
  invited: 'Invited',
  active: 'Active',
  deactivated: 'Deactivated',
  new: 'New',
  preview: 'Preview',
  saveDraft: 'Save as Draft',
  cancel: 'Cancel',
  next: 'Next',
  name: 'Name',
  type: 'Type',
  country: 'Country',
  description: 'Description',
  direct: 'Direct',
  partner: 'Partner',
  prev: 'Prev',
  back: 'Back',
  save: 'Save',
  admin: 'Admin {{ number }}',
  firstName: 'First name',
  lastName: 'Last name',
  email: 'Email',
  emailPlaceholder: 'name@example.com',
  addAdmin: 'Add Admin',
  finish: 'Finish',
  status: 'Status',
  enabled: 'Enabled',
  disabled: 'Disabled',
  visibleEnabled: 'Visible & Enabled',
  dimmedDisabled: 'Dimmed & Disabled',
  invisibleDisabled: 'Invisible & Disabled',
  access: 'Access',
  primary: 'Primary',
  secondary: 'Secondary',
  headings1: 'Headings 1',
  headings2: 'Headings 2',
  subtitle: 'Subtitle',
  loremIpsumTitle: 'Lorem ipsum dolor sit amet',
  loremIpsumText: 'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris '
    + 'nisi ut aliquip ex ea commodo consequat.Duis aute irure dolor in reprehenderit '
    + 'in voluptate velit esse cillum dolore eu fugiat nulla pariatur.',
  loremIpsumTextShort: 'Excepteur sint occaecat cupidatat non proident, sunt in culpa '
    + 'qui officia deserunt mollit anim id est laborum.',
  loremIpsumTextError: 'Excepteur sint occaecat cupidatat non proident',
  browse: 'Browse',
  dragHere: 'or drag a file here',
  companyLogo: 'Company Logo',
  partnerLogo: 'Partner Logo',
  acceptedFormats: 'Accepted formats: .png, .jpg . Maximum upload size: 5MB',
  cropAndSave: 'Crop and Save',
  close: 'Close',
  confirm: 'Confirm',
  confirmAll: 'Confirm all',
  password: 'Password',
  continue: 'Continue',
  done: 'Done',
  currentPassword: 'Current Password',
  newPassword: 'New password',
  repeatNewPassword: 'Repeat new password',
  enterPassword: 'Enter password',
  notifications: 'Notifications',
  darkMode: 'Dark mode',
  verified: 'Verified',
  security: 'Security',
  companyProfile: 'Company Profile',
  users: 'Users',
  sendInvite: 'Send Invite',
  resendInvite: 'Resend Invite',
  deactivate: 'Deactivate',
  activate: 'Activate',
  logos: 'Logos',
  colors: 'Colors',
  administrator: 'Administrator',
  facilitator: 'Facilitator',
  contributor: 'Contributor',
  auditor: 'Auditor',
  signatory: 'Signatory',
  role: 'Role',
  activateInvite: 'Activate & Invite',
  noData: 'No data',
  deactivationReason: 'Specify deactivation reason',
  archivedVCDetails: 'Archived VC map details',
  requiresReworkVCDetails: 'Requires re-work VC map details',
  deactivationDetails: 'Deactivation details',
  detailsOfTheRefusal: 'Details of the refusal',
  reason: 'Reason',
  typeYourMessage: 'Type your message here',
  person: 'Person',
  date: 'Date',
  phoneNumber: 'Phone Number',
  invalidPhone: 'Invalid Phone',
  configured: 'Configured',
  notConfigured: 'Not configured',
  delete: 'Delete',
  deleteUser: 'Are you sure you want to delete the user?',
  deleteValueChainMap: 'Are you sure you want to delete "{{name}}"?',
  deleteValueChainMapSwimlane: 'Are you sure you want to delete "{{name}}" swimlane?',
  discardDraftReview: 'Are you sure you want to cancel? The draft review will be discarded.',
  deleteSurvey: 'Are you sure you want to delete "{{name}}"?',
  duplicateSurvey: 'Are you sure you want to create a copy of "{{name}}"?',
  copyWillBeCreated: 'A copy will be created',
  deleteMA: 'Are you sure you want to delete this assessment?',
  deleteImpactScenario: 'Are you sure you want to delete this Analysis?',
  deleteConfirmation: 'Are you sure you want to delete this item?',
  thisActionCannotBeUndone: 'This action cannot be undone',
  infoWillLost: 'All information will be lost',
  userActivity: 'User activity will be suspended but all information will be retained.',
  clientActivity: 'Client activity will be suspended but all information will be retained.',
  keepEditing: 'Keep editing',
  discardChanges: 'Yes, discard changes',
  charactersLimit: '{{counter}}/{{limit}} characters',
  reset: 'Reset',
  ok: 'OK',
  search: 'Search',
  currency: 'Currency',
  create: 'Create',
  apply: 'Apply',
  notProvided: '(not provided)',
  hyphen: '-',
  notFound: 'Not found',
  noResultsFound: 'No results found',
  startTyping: 'Start typing to search',
  searching: 'Searching...',
  editRecord: 'Edit record',
  archiveRecord: 'Archive record',
  restoreRecord: 'Restore record',
  noResultsWithFilters: 'No results matching your search. <br/> Try using different keywords or filters.',
  noResults: 'No results matching your search. <br/> Try using different keywords.',
  current: 'Current',
  inProgress: 'In progress',
  underReview: 'Under review',
  readyForReview: 'Ready for review',
  requestApproval: 'Request approval',
  approved: 'Approved',
  requiresRework: 'Requires re-work',
  'ready-for-review': 'Ready for review',
  'under-review': 'Under review',
  'request-approval': 'Request approval',
  'requires-rework': 'Requires re-work',
  archived: 'Archived',
  enterNewName: 'Enter a new name',
  typeNewNameHere: 'Type new name here',
  changeOrgPathModalTitle: 'Confirm structure change',
  changeOrgPathModalDescription: 'You are about to move <b>{{prevPath}}</b> to a new parent record'
    + ' <b>{{newPath}}</b>. <br><br>This change will be applied immediately, and the new structure will take'
    + ' effect. <br><br>Are you sure you want to proceed with this move?',
  deletionRestricted: 'Deletion restricted',
  deletionRestrictedDescription: 'The ”{{name}}” swimlane cannot be deleted because it '
  + 'contains the following cards:',
  deletionRestrictedDescriptionBottom: 'To proceed, please move all cards to another swimlane and try again.',
  filter: 'Filter',
  resetAll: 'Reset all',
  hideSelected: 'Hide selected',
  currencyHint: 'Changing the currency updates only the label. Numerical values remain unchanged.',
  profitCentre: 'Profit Centre {{ number }}',
  startDate: 'FY Start Date',
  endDate: 'FY End Date',
  total: 'Total Cost',
  percentage: '% of Total Cost',
  addProfitCentre: 'Add Profit Centre',
  financials: 'Financials: {{ name }}',
  profitCentreLabel: 'Profit Centre',
  supplierTotalCost: 'Supplier Total Cost',
  supplierPercentOfTotalCost: 'Supplier % of Total Cost',
  supplierTotalProductCost: 'Suppliers Tier 1 Total Cost of Sales Spend',
  supplierPercentOfTotalProductCost: 'Suppliers Tier 1 % of Total Cost of Sales Spend',
  expectedGrowthDecline: 'Expected Growth / Decline %',
  typeDeletionRestricted: '[Type]',
  linkedTo: 'linked to',
  supplier: 'Supplier',
  customer: 'Customer',
  ownOperation: 'Own Operation',
  product: 'Product',
  profitCenter: 'Profit Centre',
  'profit-center': 'Profit Centre',
  balanceSheetAssets: 'Balance Sheet Assets',
  'balance-sheet-asset': 'Balance Sheet Asset',
  countryCodes: 'Country Codes',
  archiveRestricted: 'Archiving restricted',
  archiveRestrictedDescription: 'This operation is not permitted because',
  archiveRestrictedDescriptionBottom: 'To proceed, you must first reassign these entities '
  + 'to a different [Profit centre(s)/Supplier(s)] and retry this operation.',
  isCurrentlyInUseBy: 'is currently in use by the following active record(s):',
  skipDuplicates: 'Skip duplicates',
  replaceDuplicates: 'Replace duplicates',
  taskManagement: 'Task Management',
  add: 'Add',
  addNewUser: 'Add new user',
  created: 'Created',
  lastModified: 'Last modified',
  searchByName: 'Search by name...',
  filterBy: 'Filter by',
  assigned: 'Assigned',
  completed: 'Completed',
  deferred: 'Deferred',
  blocked: 'Blocked',
  cancelled: 'Cancelled',
  deleteTaskModalTitle: 'Are you sure you want to delete this task "{{name}}"?',
  addComment: 'Add Comment',
  typeYourCommentHere: 'Type your comment here...',
  'in-progress': 'In progress',
  addNewFile: 'Add a new file',
  allNotifications: 'All',
  unreadNotifications: 'Unread',
  markAllAsRead: 'Mark all as read',
  yesContinue: 'Yes, continue',
  configure: 'Configure',
  importFile: 'Import file',
  createNew: 'Create new',
  in_progress: 'In Progress',
  ready_for_review: 'Ready for Review',
  deleteStandardTopic: 'Are you sure you want to delete this topic?',
  hintDeleteStandardTopic: 'This action will also delete all its subtopics and key search '
  + 'words linked to topic. This action cannot be undone.',
  deleteStandardSubtopic: 'Are you sure you want to delete this subtopic?',
  hintDeleteStandardSubtopic: 'This action will also delete all key search words linked to subtopic. '
  + 'This action cannot be undone.',
  deleteSpecific: 'Are you sure you want to delete this sector specific?',
  hintDeleteSpecific: 'This action will delete sector specific.',
  deleteCompetitor: 'Are you sure you want to delete this competitor?',
  hintDeleteCompetitor: 'This action will delete sector competitor.',
  selectItem: 'Select item',
  addNew: 'Add new',
  saveAsDraft: 'Save as Draft',
  markAsDone: 'Mark as Done',
  confirmModalTitle: 'Are you sure you want to copy "{{name}}"?',
  shareModal: {
    title: 'Add emails for sending',
    emailAddresses: 'Email address',
    share: 'Share',
    addEmail: 'Add Email',
    emailPlaceholder: 'Add email address',
    invalidEmail: 'Please enter a valid email address',
    noEmailsError: 'Please add at least one email address',
    shareSuccess: 'Survey has been shared successfully',
    shareError: 'Failed to share survey. Please try again.',
    listForSending: 'List for sending',
    valueChain: 'Value Chain',
  },
  surveyAnswer: {
    initializationError: 'Failed to initialize survey session. Please try again.',
  },
  authRequiredModal: {
    title: 'Authentication Required',
    description: 'You need to be logged in to access this survey. Please log in to continue.',
    login: 'Log In',
  },
  review: 'Review',
  organizationalStructure: 'Organizational Structure',
  suppliers: 'Suppliers',
  investors: 'Investors',
  boards: 'Boards',
  employees: 'Employees',
  customers: 'Customers',
  local_communities: 'Local Communities',
  media: 'Media',
  regulators: 'Regulators',
  ngos: 'NGOs',
  nature: 'Nature',
  future_generations: 'Future Generations',
  others: 'Others',
  positive: 'Positive',
  negative: 'Negative',
  accommodation_and_food_services: 'Accommodation & Food Services',
  agriculture_and_fishing: 'Agriculture and Fishing',
  construction: 'Construction',
  distribution_and_trade: 'Distribution and Trade',
  energy: 'Energy',
  financial_services: 'Financial Services',
  health_sciences: 'Health Sciences',
  ict: 'ICT',
  manufacturing: 'Manufacturing',
  mining_and_quarrying: 'Mining and Quarrying',
  real_estate: 'Real Estate',
  transportation_and_storage_services: 'Transportation and Storage Services',
  water_and_waste_management: 'Water & Waste Management',
  Impacts: 'Are you sure you want to delete this impact?',
  Risks: 'Are you sure you want to delete this risk?',
  Opportunity: 'Are you sure you want to delete this opportunity?',
  approve: 'Approve',
  reject: 'Reject',
  template: 'Are you sure you want to reject this request?',
  hintTemplate: 'This action will also delete all information about this IRO. This action cannot be undone.',
  category: 'Category',
  refreshData: 'Refresh Data',
  refreshDataAI: 'Refresh Data (AI)',
  selectVC: 'Select Value Chain',
  noResultsItems: 'No items found.',
  sendSurvey: 'Send {{ name }}',
  valueChainPosition: 'Value Chain Position',
  valueChainCategory: 'Value Chain Category',
  respondents: 'Respondents',
  applyFilters: 'Apply Filters',
  revenue: 'Revenue',
  min: 'Min',
  max: 'Max',
  connections: 'Connections',
  seeConnectedItems: 'See connected items',
  logical: 'Logical',
  financial: 'Financial',
  service: 'Service',
  supplierOfGoods: 'Supplier of Goods',
  manufacture: 'Manufacture',
  showSelected: 'Show Selected',
  showMore: 'Show more',
  showMoreValues: 'Show more values',
  edit: 'Edit',
  importErrors: 'Import Errors',
  validationErrors: 'Validation Errors',
  deleteRecord: 'Delete record',
  error: 'Error',
  recommendations: 'Please, re-download template / save as modern .xlsx / re-export file and try again.',
  leaveSurveyWarning: 'Are you sure you want to leave? Your changes will be lost.',
  confirmLeaving: 'Confirm leaving',
  send: 'Send',
  finishMA: 'Are you sure you want to finish the assessment?',
  finishMAHint: 'Once you submit this assessment for review, you will no longer be able to edit the '
    + 'information in this assessment and any pending surveys will expire. Are you sure you want to proceed?',
  sendToReview: 'Send to Review',
  useResult: 'Use Result',
  selectCategory: 'Select',
  select: 'Select',
  duplicate: 'Duplicate',
  editName: 'Edit name',
};
